import { useEffect, useState } from 'react';

import { PinkButton } from 'core/buttons/buttons';
import propTypes from 'prop-types';
import styles from 'styles/Table.module.scss';
import useCustomMediaQuery from 'hooks/useMediaQuery';
import useRichTranslation from 'hooks/useRichTranslation';

const Table = ({ data }) => {
    const t = useRichTranslation();

    const [isFullSize, setFullSize] = useState(false);
    useCustomMediaQuery(992, (e) => {
        setFullSize(e.matches);
    });

    useEffect(() => {
        setFullSize(window.innerWidth > 992);
    }, []);

    const headers = [
        t('version-list.table.header-1'),
        t('version-list.table.header-2'),
        t('version-list.table.header-3')
    ];

    const mobileHeaders = [
        t('version-list.table.mobile-header-1'),
        t('version-list.table.mobile-header-2'),
        t('version-list.table.mobile-header-3')
    ];

    if (isFullSize) {
        return (
            <table className={styles.table}>
                <thead className={styles.header}>
                    <tr>
                        {headers.map((header, index) => (
                            <th className={styles.header_item} key={index}>
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {row.map((cellData, cellIndex) => (
                                cellIndex === 2 ?
                                    <td key={cellIndex}>
                                        <PinkButton
                                            label={t('version-list.table.button')}
                                            href={cellData}
                                            compact
                                        />
                                    </td> :
                                    <td key={cellIndex}>{cellData}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    return (
        <table className={styles.table}>
            <thead className={styles.header}>
                <tr>
                    <th className={styles.header_item}>
                        {mobileHeaders[0]}
                    </th>
                    <th className={styles.header_item}>
                        {mobileHeaders[2]}
                    </th>
                </tr>
            </thead>
            <tbody>
                {data.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                        <td>{row[0]}</td>
                        <td>
                            <PinkButton
                                label={`${t('version-list.table.button-mobile')} ${row[1]}`}
                                href={row[2]}
                                compact
                            />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

Table.propTypes = {
    data: propTypes.array.isRequired
};

export default Table;
